module.exports = __webpack_public_path__ + "static/media/start.7967e11b.mp3";